export const enErrorPages = {
	buttonText: "Take Me Home",
	description:
		"You either tried some shady route or you came here by mistake. Whichever it is, try using the navigation.",
	notFound: "404: The page you are looking for isn't here",
	serverError: "500: Internal Server Error",
	unauthorize: "401: Authorization required",
	forbidden: "403: Forbidden",
	/** Fallback rendered by the app-wide ErrorBoundary (PREC-3876). */
	boundaryTitle: "Something went wrong on this page",
	boundaryDescription:
		"The page ran into an unexpected error. Reloading usually fixes it — if it keeps happening, let us know what you were doing.",
	boundaryReload: "Reload the page",
	boundaryRetry: "Try again",
};
